import React, { Component, Suspense } from "react";
import { replacestate } from "./../../../redux_store/actions/index";
import store from "./../../../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import { defalutreduxState, isMultitenant } from "./../../../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import { updateActiveUserTime } from "../../../custom_functions/Functions";

const Menu = React.lazy(() => import('./../../Menu.jsx'));
const Material = React.lazy(() => import('../../inventory/pages/PSample'));
const ApplicationHeader = React.lazy(() => import('./../../general/ApplicationHeader.jsx'));
const ApplicationFooter = React.lazy(() => import('./../../general/ApplicationFooter.jsx'));

class PSample extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            MenuGroup: "Inventorysetup",
            ChildMenu: "SheetViewcss",
            PageName: this.props.t("Inventory.IDS_LBL_INVENTORY", { param: "" }),
            menuoption: 0,
            open: false,
            Menuselected: "",
            modalopen: false,
            ordercode: undefined,
            userrightdetails: undefined,
            helpid: "7",
            screenname: "Material",
            Materil_Globalsearch: this.props.location.state

        };

        this.MainMeunClick = this.MainMeunClick.bind(this);
        this.ELNurl = window.appUrl.ELN;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        updateActiveUserTime();
        if (this.props.location.hash !== undefined &&
            this.props.location.hash.length > 0) {
            let Sheetrun = this.props.location.hash.substring(2, this.props.location.hash.length - 1);
            if (Sheetrun !== undefined &&
                Sheetrun.split(":").length > 1 &&
                Sheetrun.split(":")[0] === "orderid") {
                let ordercode = Sheetrun.split(":")[1];
                this.setState({
                    MenuGroup: "SheetView",
                    PageName: this.props.t(
                        "menu.IDS_REGORDEREXE",
                        {
                            param: "",
                        }
                    ),
                    Menuselected: "SheetView_menu_group",
                    ordercode: ordercode
                });

            }
        }

    }

    MainMeunClick(Menu) {
        let PageName = "";
        let open = false;
        if (Menu === "SheetCreation") {
            PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
                param: "",
            });
            open = false;
        } else if (Menu === "SheetView") {
            PageName = this.props.t(
                "menu.IDS_REGORDEREXE",
                {
                    param: "",
                }
            );
            open = false;
        }
        else if (
            Menu === "SheetSetting"
        ) {
            PageName = this.props.t("menu.IDS_SHEETSETTING", {
                param: ""
            });
        } else if (Menu === "AuditTrail") {
            PageName = this.props.t("AuditTrail.ID_AUDITTRAIL", {
                param: ""
            });
            open = false;
        } else if (Menu === "UserManagement") {
            PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
                param: ""
            });
            open = false;
        } else if (Menu === "Dashboard") {
            PageName = this.props.t("Dashboard.ID_DASHBOARD", {
                param: ""
            });
            open = false;
        } else if (Menu === "Masters") {
            PageName = this.props.t("Masters.ID_MASTERS", {
                param: ""
            });
            open = false;
        } else if (Menu === "DownloadReport") {
            PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
                param: ""
            });
            open = false;
        }

        this.setState({ MenuGroup: Menu, PageName: PageName, open: open || true, Menuselected: "" });
    }

    ChilMenuclick(Menu) {
        this.setState({ ChildMenu: Menu });
    }

    onlogoutSuccess(response) {
        store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => {
            let tenantdomain = $.session.get("tenantdomain");

            if (tenantdomain !== undefined) {
                isMultitenant === 0
                    ? this.props.history.push("/")
                    : this.props.history.push("/#" + tenantdomain);
                this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));

            } else {
                this.props.history.push("/")
            }
        }, 100);
    }

    onlogoutFailure(response) {

    }

    onredirectrights(objrights) {
        this.setState({ userrightdetails: objrights });
    }

    redirecttohome() {
        this.props.history.push("/Home");
    }

    render() {
        if (!$.session.get("User")) {
            setTimeout(() => {
                let tenantdomain = $.session.get("tenantdomain");
                if (this.props && this.props.history) {
                    if (tenantdomain !== undefined) {
                        isMultitenant === 0
                            ? this.props.history.push("/")
                            : this.props.history.push("/#" + tenantdomain);

                    } else {
                        this.props.history.push("/")
                    }
                }
            }, 100);
            return <div></div>;
        }

        return (
            <div id="idElnBody">
                <Suspense fallback={<div></div>}>
                    <Menu
                        sendData={this.MainMeunClick}
                        childmenuclick={this.ChilMenuclick.bind(this)}
                        selected={this.state.Menuselected}
                        menugroup={this.state.MenuGroup}
                        screenname={this.state.screenname}
                        redirectrights={this.onredirectrights.bind(this)}
                    />
                </Suspense>
                <div id="bodycontent" className="d-flex flex-column">
                    <Suspense fallback={<div></div>}>
                        <ApplicationHeader
                            values={this.state.helpid} onlogoutSuccess={this.onlogoutSuccess.bind(this)} redirecttohome={this.redirecttohome.bind(this)}
                            onlogoutFailure={this.onlogoutFailure.bind(this)}
                            PageName={this.state.PageName} />
                    </Suspense>
                    <Suspense fallback={<div></div>}>
                        <Material rights={this.state.userrightdetails} />
                    </Suspense>
                </div>
                <Suspense fallback={<div></div>}>
                    <ApplicationFooter onlogoutSuccess={this.onlogoutSuccess.bind(this)}
                        onlogoutFailure={this.onlogoutFailure.bind(this)}
                        onforgot={this.props.onforgot} />
                </Suspense>
            </div>
        );
    }
}
export default withAlert()(withTranslation(PSample));
